
import React, { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface AnimatedButtonProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'outline' | 'ghost' | 'link' | 'destructive' | 'secondary';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  onClick?: () => void;
  disabled?: boolean;
}

export const AnimatedButton: React.FC<AnimatedButtonProps> = ({
  children,
  className,
  variant = 'default',
  size = 'default',
  onClick,
  disabled,
  ...props
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      className={cn(
        'relative overflow-hidden transition-all duration-300 font-medium',
        'after:content-[""] after:absolute after:h-full after:w-full after:top-0 after:left-0 after:rounded-md',
        'after:bg-white/20 after:opacity-0 after:scale-x-125 after:scale-y-0',
        'hover:after:scale-y-100 hover:after:opacity-100 hover:after:transition-transform',
        'after:origin-top after:duration-300',
        className
      )}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      <span className="relative z-10">{children}</span>
    </Button>
  );
};
